module.exports = __webpack_public_path__ + "img/selteclogo.9768c0b5.png";